import { network } from 'services/network';

export const getMilestones = (contractId) => {
    return network.post('api/bo/phaseperformance/getMilestones', { contract_id: contractId }).then((response) => {
        return response.data;
    });
};
